"use strict";
/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 *
 * This file is automatically generated by the generate-index.ts script.
 * To regenerate this file, run: npm run generate-tools
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOL_DEFINITIONS = void 0;
// Common exports
__exportStar(require("./common"), exports);
// Individual tool exports
__exportStar(require("./aiVisibility"), exports);
__exportStar(require("./appStoreMetadata"), exports);
__exportStar(require("./appStoreReviews"), exports);
__exportStar(require("./facebookAdsAdManagement"), exports);
__exportStar(require("./facebookAdsAdSetManagement"), exports);
__exportStar(require("./facebookAdsCampaignManagement"), exports);
__exportStar(require("./facebookAdsCreateCustomAudience"), exports);
__exportStar(require("./facebookAdsCreateLookalikeAudience"), exports);
__exportStar(require("./facebookAdsGetAdDetails"), exports);
__exportStar(require("./facebookAdsGetAdSetDetails"), exports);
__exportStar(require("./facebookAdsGetCampaignDetails"), exports);
__exportStar(require("./facebookAdsGetCreative"), exports);
__exportStar(require("./facebookAdsInsights"), exports);
__exportStar(require("./facebookAdsLeadgenFormList"), exports);
__exportStar(require("./facebookAdsLeadgenFormManagement"), exports);
__exportStar(require("./facebookAdsListAccounts"), exports);
__exportStar(require("./facebookAdsListAudiences"), exports);
__exportStar(require("./facebookAdsPixelList"), exports);
__exportStar(require("./facebookAdsPixelManagement"), exports);
__exportStar(require("./facebookAdsSearchTargeting"), exports);
__exportStar(require("./facebookAdsUpdateCustomAudience"), exports);
__exportStar(require("./fetchFromUrl"), exports);
__exportStar(require("./framerActions"), exports);
__exportStar(require("./framerWebPublisher"), exports);
__exportStar(require("./gmailAddLabelToEmail"), exports);
__exportStar(require("./gmailArchiveEmail"), exports);
__exportStar(require("./gmailCreateDraft"), exports);
__exportStar(require("./gmailDownloadAttachment"), exports);
__exportStar(require("./gmailFindEmail"), exports);
__exportStar(require("./gmailListLabels"), exports);
__exportStar(require("./gmailRemoveLabelFromEmail"), exports);
__exportStar(require("./gmailSendEmail"), exports);
__exportStar(require("./gmailUpdateOrgSignature"), exports);
__exportStar(require("./gmailUpdatePrimarySignature"), exports);
__exportStar(require("./googleAdsAddKeywords"), exports);
__exportStar(require("./googleAdsAdGroupManagement"), exports);
__exportStar(require("./googleAdsAdManagement"), exports);
__exportStar(require("./googleAdsAssetGroupManagement"), exports);
__exportStar(require("./googleAdsCalloutManagement"), exports);
__exportStar(require("./googleAdsCampaignManagement"), exports);
__exportStar(require("./googleAdsFetch"), exports);
__exportStar(require("./googleAdsGetAdDetails"), exports);
__exportStar(require("./googleAdsGetAdGroupDetails"), exports);
__exportStar(require("./googleAdsGetAssetDetails"), exports);
__exportStar(require("./googleAdsGetAssetGroupDetails"), exports);
__exportStar(require("./googleAdsGetCampaignDetails"), exports);
__exportStar(require("./googleAdsGetExtensionDetails"), exports);
__exportStar(require("./googleAdsGetKeywordDetails"), exports);
__exportStar(require("./googleAdsGetPlacementDetails"), exports);
__exportStar(require("./googleAdsGetProductDetails"), exports);
__exportStar(require("./googleAdsGetProductGroupDetails"), exports);
__exportStar(require("./googleAdsGetSearchQueryDetails"), exports);
__exportStar(require("./googleAdsInsights"), exports);
__exportStar(require("./googleAdsListResources"), exports);
__exportStar(require("./googleAdsPauseKeywords"), exports);
__exportStar(require("./googleAdsRemoveKeywords"), exports);
__exportStar(require("./googleAdsSitelinkManagement"), exports);
__exportStar(require("./googleAdsStructuredSnippetManagement"), exports);
__exportStar(require("./googleAdsUpdateBudget"), exports);
__exportStar(require("./googleAdsUpdateKeywords"), exports);
__exportStar(require("./googleDriveCreateFileFromText"), exports);
__exportStar(require("./googleDriveCreateFolder"), exports);
__exportStar(require("./googleDriveDownloadFile"), exports);
__exportStar(require("./googleDriveFindFile"), exports);
__exportStar(require("./googleDriveFindFolder"), exports);
__exportStar(require("./googleDriveGetFileById"), exports);
__exportStar(require("./googleDriveListFiles"), exports);
__exportStar(require("./googleDriveMoveFile"), exports);
__exportStar(require("./googleDriveUploadFile"), exports);
__exportStar(require("./googleSearchConsoleListSites"), exports);
__exportStar(require("./googleSearchConsolePerformanceMetrics"), exports);
__exportStar(require("./googleSearchConsoleUrlInspection"), exports);
__exportStar(require("./graphicsCreator"), exports);
__exportStar(require("./graphicsCreatorV2"), exports);
__exportStar(require("./instagramFetchPosts"), exports);
__exportStar(require("./instagramFetchProfile"), exports);
__exportStar(require("./instagramScraper"), exports);
__exportStar(require("./instagramSearch"), exports);
__exportStar(require("./linkedinCreatePost"), exports);
__exportStar(require("./linkedinGetAds"), exports);
__exportStar(require("./linkedinGetCurrentMemberProfile"), exports);
__exportStar(require("./linkedinGetProfiles"), exports);
__exportStar(require("./linkedinSearchOrganization"), exports);
__exportStar(require("./linkedinSearchPosts"), exports);
__exportStar(require("./metaAdsFetch"), exports);
__exportStar(require("./nativeApproval"), exports);
__exportStar(require("./nativeBackgroundRemoval"), exports);
__exportStar(require("./nativeBatch"), exports);
__exportStar(require("./nativeCodeRunner"), exports);
__exportStar(require("./nativeCsvLlmAction"), exports);
__exportStar(require("./nativeCsvReader"), exports);
__exportStar(require("./nativeCsvRowAction"), exports);
__exportStar(require("./nativeCsvWriter"), exports);
__exportStar(require("./nativeFileUpload"), exports);
__exportStar(require("./nativeFilter"), exports);
__exportStar(require("./nativeFlatten"), exports);
__exportStar(require("./nativeImageGenerate"), exports);
__exportStar(require("./nativeLlmResponseText"), exports);
__exportStar(require("./nativeMerge"), exports);
__exportStar(require("./nativeRouter"), exports);
__exportStar(require("./nativeSort"), exports);
__exportStar(require("./nativeVideoUnderstanding"), exports);
__exportStar(require("./playwrightGoto"), exports);
__exportStar(require("./playwrightScreenshot"), exports);
__exportStar(require("./recentTweets"), exports);
__exportStar(require("./redditSearch"), exports);
__exportStar(require("./redditSearchComments"), exports);
__exportStar(require("./searchTrafficEstimate"), exports);
__exportStar(require("./seoArticleUpdater"), exports);
__exportStar(require("./seoArticleWriter"), exports);
__exportStar(require("./seoBacklinks"), exports);
__exportStar(require("./seoDomainAnalysis"), exports);
__exportStar(require("./seoKeywordOpportunityRanker"), exports);
__exportStar(require("./seoKeywords"), exports);
__exportStar(require("./seoTechnicalAudit"), exports);
__exportStar(require("./seoUrlAnalysis"), exports);
__exportStar(require("./shopifyWebPublisher"), exports);
__exportStar(require("./sitemapper"), exports);
__exportStar(require("./twitterPost"), exports);
__exportStar(require("./webflowActions"), exports);
__exportStar(require("./wordpressActions"), exports);
__exportStar(require("./wordpressGetPage"), exports);
__exportStar(require("./wordpressPublishPage"), exports);
__exportStar(require("./wordpressUpdatePage"), exports);
__exportStar(require("./wordpressWebPublisher"), exports);
__exportStar(require("./workflowWebSearch"), exports);
__exportStar(require("./youtubeCaptions"), exports);
__exportStar(require("./youtubeDetails"), exports);
__exportStar(require("./youtubeSearch"), exports);
// Import all tool definitions
var aiVisibility_1 = require("./aiVisibility");
var appStoreMetadata_1 = require("./appStoreMetadata");
var appStoreReviews_1 = require("./appStoreReviews");
var common_1 = require("./common");
var facebookAdsAdManagement_1 = require("./facebookAdsAdManagement");
var facebookAdsAdSetManagement_1 = require("./facebookAdsAdSetManagement");
var facebookAdsCampaignManagement_1 = require("./facebookAdsCampaignManagement");
var facebookAdsCreateCustomAudience_1 = require("./facebookAdsCreateCustomAudience");
var facebookAdsCreateLookalikeAudience_1 = require("./facebookAdsCreateLookalikeAudience");
var facebookAdsGetAdDetails_1 = require("./facebookAdsGetAdDetails");
var facebookAdsGetAdSetDetails_1 = require("./facebookAdsGetAdSetDetails");
var facebookAdsGetCampaignDetails_1 = require("./facebookAdsGetCampaignDetails");
var facebookAdsGetCreative_1 = require("./facebookAdsGetCreative");
var facebookAdsInsights_1 = require("./facebookAdsInsights");
var facebookAdsLeadgenFormList_1 = require("./facebookAdsLeadgenFormList");
var facebookAdsLeadgenFormManagement_1 = require("./facebookAdsLeadgenFormManagement");
var facebookAdsListAccounts_1 = require("./facebookAdsListAccounts");
var facebookAdsListAudiences_1 = require("./facebookAdsListAudiences");
var facebookAdsPixelList_1 = require("./facebookAdsPixelList");
var facebookAdsPixelManagement_1 = require("./facebookAdsPixelManagement");
var facebookAdsSearchTargeting_1 = require("./facebookAdsSearchTargeting");
var facebookAdsUpdateCustomAudience_1 = require("./facebookAdsUpdateCustomAudience");
var fetchFromUrl_1 = require("./fetchFromUrl");
var framerActions_1 = require("./framerActions");
var framerWebPublisher_1 = require("./framerWebPublisher");
var gmailAddLabelToEmail_1 = require("./gmailAddLabelToEmail");
var gmailArchiveEmail_1 = require("./gmailArchiveEmail");
var gmailCreateDraft_1 = require("./gmailCreateDraft");
var gmailDownloadAttachment_1 = require("./gmailDownloadAttachment");
var gmailFindEmail_1 = require("./gmailFindEmail");
var gmailListLabels_1 = require("./gmailListLabels");
var gmailRemoveLabelFromEmail_1 = require("./gmailRemoveLabelFromEmail");
var gmailSendEmail_1 = require("./gmailSendEmail");
var gmailUpdateOrgSignature_1 = require("./gmailUpdateOrgSignature");
var gmailUpdatePrimarySignature_1 = require("./gmailUpdatePrimarySignature");
var googleAdsAddKeywords_1 = require("./googleAdsAddKeywords");
var googleAdsAdGroupManagement_1 = require("./googleAdsAdGroupManagement");
var googleAdsAdManagement_1 = require("./googleAdsAdManagement");
var googleAdsAssetGroupManagement_1 = require("./googleAdsAssetGroupManagement");
var googleAdsCalloutManagement_1 = require("./googleAdsCalloutManagement");
var googleAdsCampaignManagement_1 = require("./googleAdsCampaignManagement");
var googleAdsFetch_1 = require("./googleAdsFetch");
var googleAdsGetAdDetails_1 = require("./googleAdsGetAdDetails");
var googleAdsGetAdGroupDetails_1 = require("./googleAdsGetAdGroupDetails");
var googleAdsGetAssetDetails_1 = require("./googleAdsGetAssetDetails");
var googleAdsGetAssetGroupDetails_1 = require("./googleAdsGetAssetGroupDetails");
var googleAdsGetCampaignDetails_1 = require("./googleAdsGetCampaignDetails");
var googleAdsGetExtensionDetails_1 = require("./googleAdsGetExtensionDetails");
var googleAdsGetKeywordDetails_1 = require("./googleAdsGetKeywordDetails");
var googleAdsGetPlacementDetails_1 = require("./googleAdsGetPlacementDetails");
var googleAdsGetProductDetails_1 = require("./googleAdsGetProductDetails");
var googleAdsGetProductGroupDetails_1 = require("./googleAdsGetProductGroupDetails");
var googleAdsGetSearchQueryDetails_1 = require("./googleAdsGetSearchQueryDetails");
var googleAdsInsights_1 = require("./googleAdsInsights");
var googleAdsListResources_1 = require("./googleAdsListResources");
var googleAdsPauseKeywords_1 = require("./googleAdsPauseKeywords");
var googleAdsRemoveKeywords_1 = require("./googleAdsRemoveKeywords");
var googleAdsSitelinkManagement_1 = require("./googleAdsSitelinkManagement");
var googleAdsStructuredSnippetManagement_1 = require("./googleAdsStructuredSnippetManagement");
var googleAdsUpdateBudget_1 = require("./googleAdsUpdateBudget");
var googleAdsUpdateKeywords_1 = require("./googleAdsUpdateKeywords");
var googleDriveCreateFileFromText_1 = require("./googleDriveCreateFileFromText");
var googleDriveCreateFolder_1 = require("./googleDriveCreateFolder");
var googleDriveDownloadFile_1 = require("./googleDriveDownloadFile");
var googleDriveFindFile_1 = require("./googleDriveFindFile");
var googleDriveFindFolder_1 = require("./googleDriveFindFolder");
var googleDriveGetFileById_1 = require("./googleDriveGetFileById");
var googleDriveListFiles_1 = require("./googleDriveListFiles");
var googleDriveMoveFile_1 = require("./googleDriveMoveFile");
var googleDriveUploadFile_1 = require("./googleDriveUploadFile");
var googleSearchConsoleListSites_1 = require("./googleSearchConsoleListSites");
var googleSearchConsolePerformanceMetrics_1 = require("./googleSearchConsolePerformanceMetrics");
var googleSearchConsoleUrlInspection_1 = require("./googleSearchConsoleUrlInspection");
var graphicsCreator_1 = require("./graphicsCreator");
var graphicsCreatorV2_1 = require("./graphicsCreatorV2");
var instagramFetchPosts_1 = require("./instagramFetchPosts");
var instagramFetchProfile_1 = require("./instagramFetchProfile");
var instagramScraper_1 = require("./instagramScraper");
var instagramSearch_1 = require("./instagramSearch");
var linkedinCreatePost_1 = require("./linkedinCreatePost");
var linkedinGetAds_1 = require("./linkedinGetAds");
var linkedinGetCurrentMemberProfile_1 = require("./linkedinGetCurrentMemberProfile");
var linkedinGetProfiles_1 = require("./linkedinGetProfiles");
var linkedinSearchOrganization_1 = require("./linkedinSearchOrganization");
var linkedinSearchPosts_1 = require("./linkedinSearchPosts");
var metaAdsFetch_1 = require("./metaAdsFetch");
var nativeApproval_1 = require("./nativeApproval");
var nativeBackgroundRemoval_1 = require("./nativeBackgroundRemoval");
var nativeBatch_1 = require("./nativeBatch");
var nativeCodeRunner_1 = require("./nativeCodeRunner");
var nativeCsvLlmAction_1 = require("./nativeCsvLlmAction");
var nativeCsvReader_1 = require("./nativeCsvReader");
var nativeCsvRowAction_1 = require("./nativeCsvRowAction");
var nativeCsvWriter_1 = require("./nativeCsvWriter");
var nativeFileUpload_1 = require("./nativeFileUpload");
var nativeFilter_1 = require("./nativeFilter");
var nativeFlatten_1 = require("./nativeFlatten");
var nativeImageGenerate_1 = require("./nativeImageGenerate");
var nativeLlmResponseText_1 = require("./nativeLlmResponseText");
var nativeMerge_1 = require("./nativeMerge");
var nativeRouter_1 = require("./nativeRouter");
var nativeSort_1 = require("./nativeSort");
var nativeVideoUnderstanding_1 = require("./nativeVideoUnderstanding");
var playwrightGoto_1 = require("./playwrightGoto");
var playwrightScreenshot_1 = require("./playwrightScreenshot");
var recentTweets_1 = require("./recentTweets");
var redditSearch_1 = require("./redditSearch");
var redditSearchComments_1 = require("./redditSearchComments");
var searchTrafficEstimate_1 = require("./searchTrafficEstimate");
var seoArticleUpdater_1 = require("./seoArticleUpdater");
var seoArticleWriter_1 = require("./seoArticleWriter");
var seoBacklinks_1 = require("./seoBacklinks");
var seoDomainAnalysis_1 = require("./seoDomainAnalysis");
var seoKeywordOpportunityRanker_1 = require("./seoKeywordOpportunityRanker");
var seoKeywords_1 = require("./seoKeywords");
var seoTechnicalAudit_1 = require("./seoTechnicalAudit");
var seoUrlAnalysis_1 = require("./seoUrlAnalysis");
var shopifyWebPublisher_1 = require("./shopifyWebPublisher");
var sitemapper_1 = require("./sitemapper");
var twitterPost_1 = require("./twitterPost");
var webflowActions_1 = require("./webflowActions");
var wordpressActions_1 = require("./wordpressActions");
var wordpressGetPage_1 = require("./wordpressGetPage");
var wordpressPublishPage_1 = require("./wordpressPublishPage");
var wordpressUpdatePage_1 = require("./wordpressUpdatePage");
var wordpressWebPublisher_1 = require("./wordpressWebPublisher");
var workflowWebSearch_1 = require("./workflowWebSearch");
var youtubeCaptions_1 = require("./youtubeCaptions");
var youtubeDetails_1 = require("./youtubeDetails");
var youtubeSearch_1 = require("./youtubeSearch");
// Unified tool definitions
exports.TOOL_DEFINITIONS = {
    // Search & Web Tools
    aiVisibility: aiVisibility_1.aiVisibility,
    appStoreMetadata: appStoreMetadata_1.appStoreMetadata,
    appStoreReviews: appStoreReviews_1.appStoreReviews,
    fetchFromUrl: fetchFromUrl_1.fetchFromUrl,
    instagramFetchPosts: instagramFetchPosts_1.instagramFetchPosts,
    instagramFetchProfile: instagramFetchProfile_1.instagramFetchProfile,
    instagramScraper: instagramScraper_1.instagramScraper,
    instagramSearch: instagramSearch_1.instagramSearch,
    playwrightGoto: playwrightGoto_1.playwrightGoto,
    playwrightScreenshot: playwrightScreenshot_1.playwrightScreenshot,
    recentTweets: recentTweets_1.recentTweets,
    searchTrafficEstimate: searchTrafficEstimate_1.searchTrafficEstimate,
    seoTechnicalAudit: seoTechnicalAudit_1.seoTechnicalAudit,
    workflowWebSearch: workflowWebSearch_1.workflowWebSearch,
    youtubeCaptions: youtubeCaptions_1.youtubeCaptions,
    youtubeDetails: youtubeDetails_1.youtubeDetails,
    youtubeSearch: youtubeSearch_1.youtubeSearch,
    // Communication & Social
    gmailAddLabelToEmail: gmailAddLabelToEmail_1.gmailAddLabelToEmail,
    gmailArchiveEmail: gmailArchiveEmail_1.gmailArchiveEmail,
    gmailCreateDraft: gmailCreateDraft_1.gmailCreateDraft,
    gmailDownloadAttachment: gmailDownloadAttachment_1.gmailDownloadAttachment,
    gmailFindEmail: gmailFindEmail_1.gmailFindEmail,
    gmailListLabels: gmailListLabels_1.gmailListLabels,
    gmailRemoveLabelFromEmail: gmailRemoveLabelFromEmail_1.gmailRemoveLabelFromEmail,
    gmailSendEmail: gmailSendEmail_1.gmailSendEmail,
    gmailUpdateOrgSignature: gmailUpdateOrgSignature_1.gmailUpdateOrgSignature,
    gmailUpdatePrimarySignature: gmailUpdatePrimarySignature_1.gmailUpdatePrimarySignature,
    wordpressGetPage: wordpressGetPage_1.wordpressGetPage,
    wordpressPublishPage: wordpressPublishPage_1.wordpressPublishPage,
    wordpressUpdatePage: wordpressUpdatePage_1.wordpressUpdatePage,
    // Social Media
    linkedinCreatePost: linkedinCreatePost_1.linkedinCreatePost,
    linkedinGetCurrentMemberProfile: linkedinGetCurrentMemberProfile_1.linkedinGetCurrentMemberProfile,
    linkedinGetProfiles: linkedinGetProfiles_1.linkedinGetProfiles,
    linkedinSearchOrganization: linkedinSearchOrganization_1.linkedinSearchOrganization,
    linkedInSearchPosts: linkedinSearchPosts_1.linkedInSearchPosts,
    redditSearch: redditSearch_1.redditSearch,
    redditSearchComments: redditSearchComments_1.redditSearchComments,
    twitterPost: twitterPost_1.twitterPost,
    // Ads Tools
    facebookAdsAdManagement: facebookAdsAdManagement_1.facebookAdsAdManagement,
    facebookAdsAdSetManagement: facebookAdsAdSetManagement_1.facebookAdsAdSetManagement,
    facebookAdsCampaignManagement: facebookAdsCampaignManagement_1.facebookAdsCampaignManagement,
    facebookAdsCreateCustomAudience: facebookAdsCreateCustomAudience_1.facebookAdsCreateCustomAudience,
    facebookAdsCreateLookalikeAudience: facebookAdsCreateLookalikeAudience_1.facebookAdsCreateLookalikeAudience,
    facebookAdsGetAdDetails: facebookAdsGetAdDetails_1.facebookAdsGetAdDetails,
    facebookAdsGetAdSetDetails: facebookAdsGetAdSetDetails_1.facebookAdsGetAdSetDetails,
    facebookAdsGetCampaignDetails: facebookAdsGetCampaignDetails_1.facebookAdsGetCampaignDetails,
    facebookAdsGetCreative: facebookAdsGetCreative_1.facebookAdsGetCreative,
    facebookAdsInsights: facebookAdsInsights_1.facebookAdsInsights,
    facebookAdsLeadgenFormList: facebookAdsLeadgenFormList_1.facebookAdsLeadgenFormList,
    facebookAdsLeadgenFormManagement: facebookAdsLeadgenFormManagement_1.facebookAdsLeadgenFormManagement,
    facebookAdsListAccounts: facebookAdsListAccounts_1.facebookAdsListAccounts,
    facebookAdsListAudiences: facebookAdsListAudiences_1.facebookAdsListAudiences,
    facebookAdsPixelList: facebookAdsPixelList_1.facebookAdsPixelList,
    facebookAdsPixelManagement: facebookAdsPixelManagement_1.facebookAdsPixelManagement,
    facebookAdsSearchTargeting: facebookAdsSearchTargeting_1.facebookAdsSearchTargeting,
    facebookAdsUpdateCustomAudience: facebookAdsUpdateCustomAudience_1.facebookAdsUpdateCustomAudience,
    googleAdsAddKeywords: googleAdsAddKeywords_1.googleAdsAddKeywords,
    googleAdsAdGroupManagement: googleAdsAdGroupManagement_1.googleAdsAdGroupManagement,
    googleAdsAdManagement: googleAdsAdManagement_1.googleAdsAdManagement,
    googleAdsAssetGroupManagement: googleAdsAssetGroupManagement_1.googleAdsAssetGroupManagement,
    googleAdsCalloutManagement: googleAdsCalloutManagement_1.googleAdsCalloutManagement,
    googleAdsCampaignManagement: googleAdsCampaignManagement_1.googleAdsCampaignManagement,
    googleAdsFetch: googleAdsFetch_1.googleAdsFetch,
    googleAdsGetAdDetails: googleAdsGetAdDetails_1.googleAdsGetAdDetails,
    googleAdsGetAdGroupDetails: googleAdsGetAdGroupDetails_1.googleAdsGetAdGroupDetails,
    googleAdsGetAssetDetails: googleAdsGetAssetDetails_1.googleAdsGetAssetDetails,
    googleAdsGetAssetGroupDetails: googleAdsGetAssetGroupDetails_1.googleAdsGetAssetGroupDetails,
    googleAdsGetCampaignDetails: googleAdsGetCampaignDetails_1.googleAdsGetCampaignDetails,
    googleAdsGetExtensionDetails: googleAdsGetExtensionDetails_1.googleAdsGetExtensionDetails,
    googleAdsGetKeywordDetails: googleAdsGetKeywordDetails_1.googleAdsGetKeywordDetails,
    googleAdsGetPlacementDetails: googleAdsGetPlacementDetails_1.googleAdsGetPlacementDetails,
    googleAdsGetProductDetails: googleAdsGetProductDetails_1.googleAdsGetProductDetails,
    googleAdsGetProductGroupDetails: googleAdsGetProductGroupDetails_1.googleAdsGetProductGroupDetails,
    googleAdsGetSearchQueryDetails: googleAdsGetSearchQueryDetails_1.googleAdsGetSearchQueryDetails,
    googleAdsInsights: googleAdsInsights_1.googleAdsInsights,
    googleAdsListCampaigns: googleAdsListResources_1.googleAdsListCampaigns,
    googleAdsPauseKeywords: googleAdsPauseKeywords_1.googleAdsPauseKeywords,
    googleAdsRemoveKeywords: googleAdsRemoveKeywords_1.googleAdsRemoveKeywords,
    googleAdsSitelinkManagement: googleAdsSitelinkManagement_1.googleAdsSitelinkManagement,
    googleAdsStructuredSnippetManagement: googleAdsStructuredSnippetManagement_1.googleAdsStructuredSnippetManagement,
    googleAdsUpdateBudget: googleAdsUpdateBudget_1.googleAdsUpdateBudget,
    googleAdsUpdateKeywords: googleAdsUpdateKeywords_1.googleAdsUpdateKeywords,
    linkedinGetAds: linkedinGetAds_1.linkedinGetAds,
    metaAdsFetch: metaAdsFetch_1.metaAdsFetch,
    // Native/System Tools
    nativeApproval: nativeApproval_1.nativeApproval,
    nativeBackgroundRemoval: nativeBackgroundRemoval_1.nativeBackgroundRemoval,
    nativeBatch: nativeBatch_1.nativeBatch,
    nativeCodeRunner: nativeCodeRunner_1.nativeCodeRunner,
    nativeCsvRowAction: nativeCsvRowAction_1.nativeCsvRowAction,
    nativeFileUpload: nativeFileUpload_1.nativeFileUpload,
    nativeFilter: nativeFilter_1.nativeFilter,
    nativeFlatten: nativeFlatten_1.nativeFlatten,
    nativeMerge: nativeMerge_1.nativeMerge,
    nativeRouter: nativeRouter_1.nativeRouter,
    nativeSort: nativeSort_1.nativeSort,
    sitemapper: sitemapper_1.sitemapper,
    // AI/LLM Tools
    graphicsCreator: graphicsCreator_1.graphicsCreator,
    graphicsCreatorV2: graphicsCreatorV2_1.graphicsCreatorV2,
    nativeCsvLlmAction: nativeCsvLlmAction_1.nativeCsvLlmAction,
    nativeCsvReader: nativeCsvReader_1.nativeCsvReader,
    nativeCsvWriter: nativeCsvWriter_1.nativeCsvWriter,
    nativeImageGenerate: nativeImageGenerate_1.nativeImageGenerate,
    nativeLlmResponseText: nativeLlmResponseText_1.nativeLlmResponseText,
    nativeVideoUnderstanding: nativeVideoUnderstanding_1.nativeVideoUnderstanding,
    seoArticleUpdater: seoArticleUpdater_1.seoArticleUpdater,
    seoArticleWriter: seoArticleWriter_1.seoArticleWriter,
    // Integration Tools
    googleDriveCreateFileFromText: googleDriveCreateFileFromText_1.googleDriveCreateFileFromText,
    googleDriveCreateFolder: googleDriveCreateFolder_1.googleDriveCreateFolder,
    googleDriveDownloadFile: googleDriveDownloadFile_1.googleDriveDownloadFile,
    googleDriveFindFile: googleDriveFindFile_1.googleDriveFindFile,
    googleDriveFindFolder: googleDriveFindFolder_1.googleDriveFindFolder,
    googleDriveGetFileById: googleDriveGetFileById_1.googleDriveGetFileById,
    googleDriveListFiles: googleDriveListFiles_1.googleDriveListFiles,
    googleDriveMoveFile: googleDriveMoveFile_1.googleDriveMoveFile,
    googleDriveUploadFile: googleDriveUploadFile_1.googleDriveUploadFile,
    // Other Tools
    framerActions: framerActions_1.framerActions,
    framerWebPublisher: framerWebPublisher_1.framerWebPublisher,
    googleSearchConsoleListSites: googleSearchConsoleListSites_1.googleSearchConsoleListSites,
    googleSearchConsolePerformanceMetrics: googleSearchConsolePerformanceMetrics_1.googleSearchConsolePerformanceMetrics,
    googleSearchConsoleUrlInspection: googleSearchConsoleUrlInspection_1.googleSearchConsoleUrlInspection,
    seoBacklinks: seoBacklinks_1.seoBacklinks,
    seoDomainAnalysis: seoDomainAnalysis_1.seoDomainAnalysis,
    seoKeywordOpportunityRanker: seoKeywordOpportunityRanker_1.seoKeywordOpportunityRanker,
    seoKeywords: seoKeywords_1.seoKeywords,
    seoUrlAnalysis: seoUrlAnalysis_1.seoUrlAnalysis,
    shopifyWebPublisher: shopifyWebPublisher_1.shopifyWebPublisher,
    webflowActions: webflowActions_1.webflowActions,
    wordpressActions: wordpressActions_1.wordpressActions,
    wordpressWebPublisher: wordpressWebPublisher_1.wordpressWebPublisher,
};
// Initialize the TOOL_DEFINITIONS in common.ts
(0, common_1.initializeToolDefinitions)(exports.TOOL_DEFINITIONS);
